<template>
<span @click="click">
  <slot></slot>
</span>
</template>
<script>
import selectFile from 'utils/selectFile'

export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  name: 'select-file',
  props: ['value', 'accept', 'multiple', 'disabled'],
  methods: {
    click () {
      /* istanbul ignore next */
      selectFile({
        accept: this.accept,
        multiple: !!this.multiple,
        disabled: !!this.disabled,
      }, (files, event) => {
        let new_val = (this.value || []).concat(files)
        this.$emit('change', new_val)
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/common/SelectFile.vue